import React from 'react';
import { QueryResult, useQuery } from '@apollo/client';
import {
  FetchOverdueInvoicesForHomePageInPpcQuery,
  FetchOverdueInvoicesForHomePageInPpcQueryVariables,
  InvoiceStatus,
  SortDirection,
  InvoicePaymentMethod,
} from '@css-xp/graphtypes/src/generated-types-new';
import { fetchOverdueInvoicesForHomePageInPPC } from './queries/fetch-overdue-invoices-for-home-page';
import { MAX_WIDGET_ITEMS } from '../../../constants/widget';

type ChildrenProp = (
  args: QueryResult<FetchOverdueInvoicesForHomePageInPpcQuery, FetchOverdueInvoicesForHomePageInPpcQueryVariables>
) => JSX.Element;

export const OverdueInvoicesQueryWrapper = ({
  txaId,
  children,
  hasPayOnAccount,
}: {
  txaId: string;
  children: ChildrenProp;
  hasPayOnAccount?: boolean;
}): JSX.Element => {
  const queryResult = useQuery<
    FetchOverdueInvoicesForHomePageInPpcQuery,
    FetchOverdueInvoicesForHomePageInPpcQueryVariables
  >(fetchOverdueInvoicesForHomePageInPPC, {
    variables: {
      id: txaId,
      searchOptions: {
        first: MAX_WIDGET_ITEMS,
        sort: {
          sortFields: ['dueDateIsLte', 'grandTotal'],
          sortFieldsDirections: [SortDirection.ASC, SortDirection.DESC],
        },
      },
      filterOptions: {
        not: [
          {
            key: 'status',
            value: InvoiceStatus.UNCOLLECTIBLE,
          },
          {
            key: 'status',
            value: InvoiceStatus.DRAFT,
          },
          {
            key: 'status',
            value: InvoiceStatus.PAID,
          },
          {
            key: 'status',
            value: InvoiceStatus.PAYMENT_DEFERRED,
          },
          // hiding on-account invoices from the widget.
          ...(hasPayOnAccount
            ? [
                {
                  key: 'paymentMethod',
                  value: InvoicePaymentMethod.DEFERRED,
                },
              ]
            : []),
        ],
      },
    },
    skip: !txaId,
    fetchPolicy: 'cache-and-network',
  });
  return children(queryResult);
};
